
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import FactoryIcon from '@mui/icons-material/Factory';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';



const DesignMgmt = {
  id: '10',
  title: 'Design Mgmt',
  type: 'group',
  role:'PHARMA_OMS_DESIGNER',
  children: [
    {
      id: 'tasklist',
      title: 'My Task(s)',
      type: 'item',
      url: '/',
      bottomMenu:'MYTASKS',
      icon: FormatListNumberedIcon
    },
    // {
    //   id: 'productunderdesign',
    //   title: 'Product(s) under Design',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu:'DESIGNER',
    //   icon: FactoryIcon
    // },
    // {
    //   id: 'pharmaorder',
    //   title: 'Order List',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu:'ORDERS',
    //   icon: ShoppingBagIcon
    // }
  ]
};

export default DesignMgmt;